"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VCustomDateRangeV2 = void 0;
var react_1 = __importStar(require("react"));
var datetime_1 = require("@blueprintjs/datetime");
var moment_1 = __importDefault(require("moment"));
var mobx_react_1 = require("mobx-react");
var CustomDateRangeV2Store_1 = require("./stores/CustomDateRangeV2Store");
var types_1 = require("./types/types");
var styles_1 = require("./styles/styles");
exports.VCustomDateRangeV2 = (0, mobx_react_1.observer)(function (props) {
    var defaultEndTimeWithEndDay = props.defaultEndTimeWithEndDay, fieldState = props.fieldState, _a = props.format, format = _a === void 0 ? 'MM/DD/YYYY' : _a, onChange = props.onChange, value = props.value, onChangeShortcut = props.onChangeShortcut;
    var _b = (0, mobx_react_1.useLocalStore)(function () { return new CustomDateRangeV2Store_1.CustomDateRangeV2Store(onChangeShortcut); }), range = _b.range, setIsChangedByDayPicker = _b.setIsChangedByDayPicker, isChangedByDayPicker = _b.isChangedByDayPicker, removePopoverDismiss = _b.removePopoverDismiss, handleOnChange = _b.handleOnChange, handleChangeFromExterior = _b.handleChangeFromExterior, setShortcuts = _b.setShortcuts, setComponentRef = _b.setComponentRef;
    var shortcuts = (0, react_1.useMemo)(function () {
        setShortcuts(props.shortcuts || types_1.DEFAULT_SHORTCUTS);
        return props.shortcuts || types_1.DEFAULT_SHORTCUTS;
    }, [props.shortcuts]);
    var propsValue = (0, react_1.useMemo)(function () {
        return (fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) || value;
    }, [fieldState === null || fieldState === void 0 ? void 0 : fieldState.value, value]);
    (0, react_1.useEffect)(function () {
        handleChangeFromExterior(propsValue, format);
    }, [propsValue]);
    var isUserDefined = (0, react_1.useMemo)(function () {
        if (!range[0] && !range[1]) {
            return true;
        }
        return !shortcuts.some(function (shortcut) {
            return (0, moment_1.default)(shortcut.dateRange[0] || undefined).format('MM/DD/YYYY hh:mm a') === (0, moment_1.default)(range[0] || undefined).format('MM/DD/YYYY hh:mm a') &&
                (0, moment_1.default)(shortcut.dateRange[1] || undefined).format('MM/DD/YYYY hh:mm a') === (0, moment_1.default)(range[1] || undefined).format('MM/DD/YYYY hh:mm a');
        });
    }, [range]);
    var onDayMouseEnter = function (day) {
        if (!isChangedByDayPicker) {
            setIsChangedByDayPicker(true)();
        }
    };
    var _c = (0, react_1.useMemo)(function () {
        var _a;
        var hasTimeProps = (_a = format === null || format === void 0 ? void 0 : format.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes('hh');
        if (!hasTimeProps) {
            return {
                hasTimeProps: hasTimeProps,
                timePickerProps: undefined
            };
        }
        return {
            hasTimeProps: hasTimeProps,
            timePickerProps: {
                useAmPm: format === 'MM/DD/YYYY hh:mm a',
                onFocus: setIsChangedByDayPicker(false)
            }
        };
    }, [format]), timePickerProps = _c.timePickerProps, hasTimeProps = _c.hasTimeProps;
    return (react_1.default.createElement(styles_1.StyledDateRange, __assign({ ref: setComponentRef, isUserDefined: isUserDefined, allowSingleDayRange: true, timePrecision: hasTimeProps ? datetime_1.TimePrecision.MINUTE : undefined }, momentFormatter(format), { shortcuts: shortcuts, closeOnSelection: false, value: range, onChange: handleOnChange(fieldState, onChange, defaultEndTimeWithEndDay), popoverProps: {
            shouldReturnFocusOnClose: false,
            onOpened: removePopoverDismiss,
            minimal: true
        }, timePickerProps: timePickerProps, dayPickerProps: {
            onDayMouseEnter: onDayMouseEnter
        }, highlightCurrentDay: true, endInputProps: {
            onFocus: setIsChangedByDayPicker(true),
            value: (range === null || range === void 0 ? void 0 : range[1]) ? (0, moment_1.default)(range === null || range === void 0 ? void 0 : range[1]).format(format) : ''
        } })));
});
exports.default = exports.VCustomDateRangeV2;
var momentFormatter = function (format) {
    return {
        formatDate: function (date) { return (0, moment_1.default)(date).format(format); },
        parseDate: function (str) { return (0, moment_1.default)(str, format).toDate(); },
        placeholder: "".concat(format, " (moment)")
    };
};
